module.exports = __webpack_public_path__ + "static/media/business-deal-cpi9.406ad010.svg";